<template>
    <div class="template">
        <div class="template-body">
            <div class="template-group">
                <!-- 标题 -->
                <div class="panel-row">
                    <p class="panel-row-label">
                        <span>创意名称</span>
                        <span v-if="htmlError.name && blur.name" class="panel-row-error">
                            <Icon class="panel-row-error-icon" type="close-circled"></Icon>请输入25个字符以内的创意名称
                        </span>
                    </p>
                    <Input
                        @on-blur="blur.name = true"
                        v-model="htmlList[0].name"
                        :placeholder="`必填，限制25个字符`"
                        :maxlength="100"
                    />
                </div>
                <div class="panel-row status-row">
                    <p class="panel-row-label">展示落地页</p>
                    <i-switch v-model="htmlList[0].h5Type" size="large" :true-value="2" :false-value="1">
                        <span slot="open">ON</span>
                        <span slot="close">OFF</span>
                    </i-switch>
                </div>
                <div v-if="htmlList[0].h5Type == 1" class="panel-row">
                    <p class="panel-row-label">
                        <span>创意链接</span>
                        <span v-if="htmlError.h5Url && blur.h5Url" class="panel-row-error">
                            <Icon class="panel-row-error-icon" type="close-circled"></Icon>请输入正确的创意链接
                        </span>
                        <a :href="htmlList[0].h5Url" target="_blank" v-else style="margin-left: 0.3rem; color: #169bd5"
                            >预览</a
                        >
                    </p>
                    <Input
                        @on-blur="blur.h5Url = true"
                        v-model="htmlList[0].h5Url"
                        :placeholder="`必填，必须以http://或https://开头`"
                    />
                </div>
                <div v-else class="panel-row">
                    <p class="panel-row-label">
                        <span>落地页</span>
                        <span v-if="htmlError.clickUrl" class="panel-row-error">
                            <Icon class="panel-row-error-icon" type="close-circled"></Icon>请在广告系列填入正确的落地页
                        </span>
                        <a
                            :href="seriesParams.clickUrl"
                            target="_blank"
                            v-else
                            style="margin-left: 0.3rem; color: #169bd5"
                            >预览</a
                        >
                    </p>
                    <Input
                        v-model="seriesParams.clickUrl"
                        readonly
                        :placeholder="`必填，必须以http://或https://开头`"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixins from '@/mixins/index';
export default {
    mixins: [mixins],
    props: {
        blur: {
            type: Object,
        },
    },
    computed: {
        seriesParams() {
            return this.$store.state.newPromotion.seriesParams;
        },
        htmlList() {
            return this.$store.state.newPromotion.htmlList;
        },
        htmlError() {
            const params = this.htmlList[0];
            return {
                name: !params.name,
                h5Url: !this.mixinUrlReg(params.h5Url),
                clickUrl: !this.mixinUrlReg(this.seriesParams.clickUrl),
            };
        },
    },
};
</script>
<style lang="scss">
.html-creative {
    padding: 0 0.1rem;
    padding-bottom: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/Creative/HtmlCreative.vue